<svelte:options accessors/>


<script>

    let metodo_envio_otp = "celular";
    export let csrf_token;


</script>

<form method="post" class="w-100">
    <input type="hidden" name="csrfmiddlewaretoken" value="{csrf_token}">
    <div class="box-l sx-3">
        <label for="radio-email" class="box-l sx-ii pointer">
            <input id="radio-email" type="radio" name="metodo" value="email" bind:group={metodo_envio_otp} required>

            <span>Correo</span>
        </label>
        <label for="radio-cel" class="box-l sx-ii pointer">
            <input id="radio-cel" type="radio" name="metodo" value="celular" bind:group={metodo_envio_otp} required>
            <span>Celular</span>
        </label>
    </div>

    <div class="naui-field mb-iii">
        <select class="naui-input w-100" name="tipo-documento" required>
            <option selected hidden value="">Tipo de documento</option>
            <option value="CC">Cédula de ciudadanía</option>
            <option value="NIT">NIT</option>
            <option value="CE">Cédula de extranjería</option>
            <option value="INT">Clave intermediario</option>
        </select>
    </div>
    <div class="naui-field mb-iii">
        <input type="text" class="naui-input w-100" placeholder="Número de documento" name="numero-documento" required/>
    </div>
    <div class="naui-field mb-15">
        {#if metodo_envio_otp === 'email'}
            <input type="email" class="naui-input w-100" placeholder="E-mail" name="email_cel" required/>
        {:else}
            <input type="number" class="naui-input w-100" placeholder="Celular" name="email_cel" required/>
        {/if}
    </div>
    <div class="box mb-15">
        <button class="btn accent solid w-100" type="submit">Enviar clave temporal</button>
    </div>
</form>
